import React from 'react';
import removeCommasToNumber from '../commonJS/removeCommasToNumber';
import { autoLinks } from '../commonJS/autoLinks';
import { FormControl } from 'react-bootstrap';


const TextareaWithLink = props => {
   const { languageData, languageCode } = window.myConsts;

   return (
      <div>
         {
            props.disabled ?
               <div
                  // id='notesLink'
                  className='textareaLinkStyle'
                  style={{
                     ...props.style,
                     maxHeight: 114
                  }}
                  dangerouslySetInnerHTML={{ __html: autoLinks(props.value || '') }}
               ></div>
               :
               <FormControl
                  style={{
                     ...props.style,
                     maxHeight: 114
                  }}
                  onFocus={props.onFocus}
                  onBlur={props.onBlur}
                  disabled={props.disabled || false}
                  value={props.value || ''}
                  onChange={props.onChange || null}
                  componentClass={props.componentClass || 'textarea'}
                  rows={props.rows || 3}
                  placeholder={
                     (props.disabled || false)
                        ? null
                        : (props.placeholder || languageData['529'][languageCode] || null)
                  }
               />
         }
      </div>
   );
};

export default TextareaWithLink;


// WEBPACK FOOTER //
// ./src/commonComponents/TextareaWithLink.jsx